import * as React from "react";
import { IdLeagueGifts } from "../../constants/IdLeagueGifts";
import { IdStyles } from "../../less/IdStyles";
import { BaseButton } from "../generic/base-button/BaseButton";
import { IdButtonType } from "../generic/base-button/IdButtonType";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
import { buttonGiftInfoMap } from "./buttonGiftInfoMap";
export var ButtonGift = function (_a) {
    var giftType = _a.giftType, onClick = _a.onClick;
    if (!buttonGiftInfoMap.has(giftType)) {
        return React.createElement(React.Fragment, null);
    }
    // @ts-ignore
    var _b = buttonGiftInfoMap.get(giftType), buttonColour = _b.buttonColour, icon = _b.icon, loca = _b.loca;
    var disabled = giftType === IdLeagueGifts.LeaguePremiumOffer;
    return (React.createElement(BaseButton, { name: buttonColour, styleId: IdButtonType.ButtonRectangleLargeThick, onClick: onClick, disabled: disabled },
        React.createElement("div", { className: "flex flex--guts flex--stacked" },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
            React.createElement(TextLoca, { id: loca, className: IdStyles.TextButtonDefault }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/ButtonGift.tsx
// module id = 2790
// module chunks = 3